import React from 'react';
import { Center, Spinner } from '@chakra-ui/react';

const Loading: React.FC = () => {
  return (
    <Center h="100vh">
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="accent.400"
        size="xl"
      />
    </Center>
  );
};

export default Loading;
